import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/room_board.svg")